const v34 = (state: any) => {
  return {
    ...state,
    filters: {
      ...state.filters,
      freelancerFilters: {
        ...state.filters.freelancerFilters,
        gender: [],
      },
    },
  };
};

export default v34;
